import { getElementDescendant } from "../../helpers/utils";

export type OrbitTone =
  | "danger"
  | "default"
  | "info"
  | "muted"
  | "success"
  | "warning";

export const getOrbitDisplayValue = (value: unknown) => {
  if (value === undefined || value === null || value === "") {
    return "-";
  }

  if (typeof value === "object") {
    const wrapped = value as { units?: unknown; value?: unknown };
    const wrappedValue = wrapped.value;

    if (
      wrappedValue === undefined ||
      wrappedValue === null ||
      wrappedValue === ""
    ) {
      return "-";
    }

    return wrapped.units ? `${wrappedValue} ${wrapped.units}` : `${wrappedValue}`;
  }

  return `${value}`;
};

export const getOrbitNestedValue = (element: unknown, path: string[]) =>
  getElementDescendant(element, [...path]) as unknown;

export const getOrbitNestedDisplayValue = (
  element: unknown,
  path: string[],
) => getOrbitDisplayValue(getOrbitNestedValue(element, path));

export const getOrbitStatusTone = (statusValue: unknown): OrbitTone => {
  const status = getOrbitDisplayValue(statusValue).toUpperCase();

  if (status === "ERROR" || status === "REJECTED") return "danger";
  if (status === "PENDING" || status === "PROCESSING") return "warning";
  if (status === "SCREENING") return "info";
  if (status === "PROCESSED") return "success";

  return "muted";
};
